import { useTranslation } from "react-i18next";
import ProfileEmailChange from "./components/ProfileEmailChange";
import React from "react";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { CustomButton } from "../../atoms/CustomButton";

const LmcUserViewSettings = ({
  handleFlipToFront,
}: {
  handleFlipToFront: () => void;
}) => {
  const { t } = useTranslation("clientView");

  return (
    <div className="w-full h-full">
      <div className="grid grid-rows-[1fr_auto] w-full h-full min-h-0 relative rounded-xl overflow-hidden">
        <div className="row-start-1 row-end-2 min-h-0">
          <div
            className="h-full overflow-y-auto overscroll-contain touch-pan-y"
            style={{ WebkitOverflowScrolling: "touch" }}
          >
            <div className="rounded-xl overflow-hidden shadow-lg border border-white/20 bg-gray-950/95 backdrop-blur m-3 sm:m-4 flex flex-col gap-4 px-5 sm:px-6 py-6">
              <div className="flex items-start justify-between gap-2">
                <CustomButton
                  variant="none"
                  size="icon"
                  onClick={handleFlipToFront}
                  tooltip={String(t("lmcUser.key5"))}
                  icon={
                    <HiOutlineArrowLeft className="w-5 h-5 rtl:rotate-180" />
                  }
                  className="p-2 rounded-full bg-white/10 border border-white/15 text-white hover:bg-white/20 transition"
                />
              </div>
              <div className="flex-1 flex flex-col gap-4">
                <div className="w-full flex flex-col justify-start items-center bg-gray-800">
                  <ProfileEmailChange />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LmcUserViewSettings;
